import React, {useEffect} from 'react';
import Hero from '../components/Hero';
import AboutPreview from '../components/AboutPreview';
import ServicesPreview from '../components/ServicesPreview';
import PortfolioPreview from '../components/PortfolioPreview';
import BlogPreview from '../components/BlogPreview';
import ContactCTA from '../components/ContactCTA';

const Home = () => {
useEffect(() => {
    document.title = 'Home | Bularis Tech';
    }, []);
return (
    <>
    <Hero />
    <AboutPreview />
    <ServicesPreview />
    <PortfolioPreview />
    <BlogPreview />
    <ContactCTA />
    </>
);
}

export default Home;
